import React from 'react';
import MeetingsCard from '../Advisor/components/HHMeetings/MeetingsCard';

export default function Meeting({ meetingData, query }) {
    return (
        <MeetingsCard meeting={meetingData} query={query} />
    );
}
